// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__IIBm+","navigation":"layout_navigation__oUJeb","content":"layout_content__rFNit"};